export const INVALID_TAX_AMOUNT_HELPER_TEXT = 'Nombre positif, deux décimales au plus (ex. 5,5 ou 20)';
